import { Reducer } from 'redux'
import { ICPData } from '../PartnerIQ/reducer'
import { AllIcpPayload, IcpActionTypes } from './action'

export interface AllIcpData {
  total: number
  icps: ICPData[] | null
}

export const initialState: AllIcpData = {
  total: 0,
  icps: null,
}

type actionType =
  | {
      type: IcpActionTypes.SET_ALL_ICP_DATA
      payload: AllIcpPayload
    }
  | {
      type: IcpActionTypes.UPDATE_ICP
      payload: { icpId: string; updates: Partial<ICPData> }
    }

export const reducer: Reducer<AllIcpData, actionType> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case IcpActionTypes.SET_ALL_ICP_DATA: {
      return {
        ...state,
        total: action.payload.total,
        icps: action.payload.icps,
      }
    }
    case IcpActionTypes.UPDATE_ICP: {
      if (!state.icps) return state
      const updatedIcps = state.icps.map(icp =>
        icp.id === action.payload.icpId
          ? { ...icp, ...action.payload.updates }
          : icp
      )
      return {
        ...state,
        icps: updatedIcps,
      }
    }
    default:
      return state
  }
}
